import { createFileRoute } from '@tanstack/react-router';
import { OrganizationsPage } from '../../../pages';
import { PagesProvider } from '../../../pages/providers/pages-provider';
import { beforeLoadVizitUserValidation } from '../../../router';
import { NavbarPageTemplate } from '../../../templates';

export const Route = createFileRoute('/_authenticated/organizations/')({
  staticData: {
    pageName: 'Organizations',
  },
  beforeLoad: ({ context, location }) => beforeLoadVizitUserValidation(context, location),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PagesProvider template={NavbarPageTemplate}>
      <OrganizationsPage />
    </PagesProvider>
  );
}
